import type {
  OnChangeFn,
  PaginationState,
  SortingState,
} from '@tanstack/react-table';

import type { UpcomingPayment } from '~entities/payment/api/upcoming-payments/types';

export const UPCOMING_PAYMENT_STATUS_BADGE = {
  paid: { variant: 'default' as const, label: 'Paid' },
  pending: { variant: 'secondary' as const, label: 'Pending' },
  failed: { variant: 'destructive' as const, label: 'Failed' },
  upcoming: { variant: 'outline' as const, label: 'Upcoming' },
  scheduled: { variant: 'outline' as const, label: 'Scheduled' },
  cancelled: { variant: 'secondary' as const, label: 'Cancelled' },
  void: { variant: 'secondary' as const, label: 'Void' },
  'invoice scheduled': {
    variant: 'outline' as const,
    label: 'Invoice Scheduled',
  },
} as const;

export interface UpcomingPaymentsTableProps {
  formatCurrency: (amount: number) => string;
  isUpdating: boolean;
  onPaginationChange: OnChangeFn<PaginationState>;
  onSortingChange: OnChangeFn<SortingState>;
  pagination: PaginationState;
  payments: Array<UpcomingPayment>;
  rowCount: number;
  sorting: SortingState;
}
